import Text from 'src/components/Typography/Text'

export const RequiredMark = (label: React.ReactNode, { required }: { required: boolean }) => (
  <>
    {label}
    {required ? <Text colorToken="red">&nbsp;*</Text> : null}
  </>
)
